module.exports = __webpack_public_path__ + "img/gps-place.1550246b.svg";